import { Carousel } from "@mantine/carousel";
import { Center, Stack, Image, Text, Group } from "@mantine/core";

import { STARS_ICON } from "constants/app";
import classes from "./index.module.css";

interface IReview {
  author: string;
  message: string;
}

const Review = ({ author, message }: IReview) => {
  return (
    <Carousel.Slide>
      <Center px={28}>
        <Stack align="center">
          <Stack gap={10} w="100%">
            <Group justify="center">
              <Image
                src={STARS_ICON}
                className={classes.stars}
                alt="Review stars"
                width="auto"
                height="auto"
              />
            </Group>
          </Stack>
          <Text className={classes.message}>{message}</Text>
          <Text className={classes.author}>{author}</Text>
        </Stack>
      </Center>
    </Carousel.Slide>
  );
};

export default Review;
